import { Typography } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import FavoriteIcon from "@mui/icons-material/Favorite";
import DiamondIcon from "@mui/icons-material/Diamond";
import {
  JEWELRY_PRODUCTION,
  THANK_YOU_NOTE,
} from "../../../Constants/copy/copy";

const BADGES = [
  { Icon: AccessTimeIcon, text: JEWELRY_PRODUCTION },
  { Icon: FavoriteIcon, text: THANK_YOU_NOTE },
  { Icon: DiamondIcon, text: "Jewerly Shop Doro" },
];

export const TrustBadges = () => (
  <div className="sp-trust-list">
    {BADGES.map(({ Icon, text }, index) => (
      <div className="sp-trust-item" key={index}>
        <Icon className="sp-trust-icon" />
        <Typography className="sp-trust-text">{text}</Typography>
      </div>
    ))}
  </div>
);

export default TrustBadges;
